import { Dispatch, configureStore } from '@reduxjs/toolkit'
import {
  useSelector as useReduxSelector,
  useDispatch as useReduxDispatch,
} from 'react-redux'
import rootReducer from './reducers'

export const store = configureStore({
  reducer: rootReducer,
})

export type Payload<E = unknown, T = unknown> = {
  rejectValue: { code: string; message: string; details?: E; detail?: T }
  state: RootState
  dispatch?: Dispatch
  extra?: unknown
  serializedErrorType?: unknown
  pendingMeta?: unknown
  fulfilledMeta?: unknown
  rejectedMeta?: unknown
}

export type RootState = ReturnType<typeof store.getState>
type AppDispatch = typeof store.dispatch

export const useDispatch = useReduxDispatch.withTypes<AppDispatch>()
export const useSelector = useReduxSelector.withTypes<RootState>()

export * from './clear-stores'
